import { GraphQLQueryClass } from "@harea/component";
import { TTimeOff } from "@harea/component";

export class TimeOffQuery implements GraphQLQueryClass<TTimeOff, TResponse>{
    public queryKey: string = 'App.harea.timeoff';
    public gql: string = `
    query TimeOffQuery($id:Float){
        timeoff(filter:{id:$id}){
           id 
           description 
           dateBegin 
           dateEnd 
           hourBegin 
           hourEnd 
           status
           order
           entity
           entityId
           data
           dateArchive
           reason
           refusalReason
           solde
           countWorkingDays
           payrollDeductionAmount
           maternitySalaryEstimate {
               salary
               employerRate
               periods { month dateBegin dateEnd days employer cnaps }
           }
           type {
               id
               designation
               isPaid
           }
           isDeletable 
           isEditable 
           isExpired
           isRSVP
           isRevocked
           isValidated
           isClosed
           isDeadLineRespected
            isWorkExtension
            unpaidLeaveMode
            isExceptionalPaid
            negativeBalance
            deductFromPay
            exception
            notificationTime
           repetition
           repetitionDateStart
           repetitionDateEnd
           meet
           estimation
           progression
           relativePosition
           employee {
               id 
               fullName 
               firstName 
               lastName 
               profilePicture {
                   id 
                   name
               }
               department {
                   id
                   designation
               }
           }
           approvals {
               id
               approver {
                   id
                   fullName
               }
               isApproved
               isRefused
           }
           userCreator {
               id 
               employee {
                    id
                    fullName 
                    firstName 
                    lastName 
                    email 
                    profilePicture { 
                        id 
                        name 
                    }
               }
           }
           createdAt
           cover {
               id
           }
           files {
               id
               name
           }
           labels {
               id
               value
               color
           }
           maternityLeave {
               id
               probableDeliveryDate
               dateBegin
               dateEnd
               status
               pregnancyCertificate {
                   id
                   name
               }
               leaveRequest {
                   id
                   name
               }
               maternityBooklet {
                   id
                   name
               }
               medicalProofs {
                   id
                   name
               }
           }
        }
      }
    `;
    variables?: any;
    constructor(variables?: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): TTimeOff {
        return data.timeoff
    };
}

export type TResponse = {
    timeoff: TTimeOff
}
